<template>
  <div class="p2p-page narrow">
    <section class="p2p-card" aria-labelledby="accept-title">
      <h1 id="accept-title" class="p2p-h1">Review autopilot posts</h1>
      <p v-if="!done" class="p2p-text">You were invited to approve or reject another member's autopilot posts. Accepting lets you see and decide the posts waiting for them. You cannot edit their posts, use their credits for anything else or change their connected accounts.</p>
      <div v-if="error" class="p2p-alert bad">{{ error }}</div>
      <div v-if="done" class="p2p-alert good">You now review autopilot posts for {{ done.owner_email || 'them' }}.</div>
      <div class="p2p-row">
        <button v-if="!done" type="button" class="p2p-btn" :disabled="busy || !token" @click="accept">{{ busy ? 'Accepting…' : 'Accept invitation' }}</button>
        <router-link v-else :to="'/approvals?owner=' + done.owner_id" class="p2p-btn">Open their approvals</router-link>
        <router-link v-if="!done" to="/" class="p2p-btn ghost">Not now</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { post, message } from '../api';

export default {
  name: 'AcceptReviewer',
  data: () => ({ busy: false, error: '', done: null }),
  computed: { token() { return String(this.$route.query.token || ''); } },
  methods: {
    async accept() {
      this.busy = true;
      this.error = '';
      try {
        this.done = await post('/reviewers/accept', { token: this.token });
      } catch (error) {
        this.error = message(error);
      } finally {
        this.busy = false;
      }
    }
  }
};
</script>
